import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useModuleRights } from '@work4all/data';

import { ModuleAccessRightDenyReason } from '@work4all/models/lib/Enums/ModuleAccessRightDenyReason.enum';
import { ModuleAccessRightType } from '@work4all/models/lib/Enums/ModuleAccessRightType.enum';

export const useTimeTrackingDisabled = () => {
  const { rights } = useModuleRights();
  const { t } = useTranslation();

  return useMemo(() => {
    let disabled = false;
    let reason: string | null = null;

    const right = rights.find(
      (right) => right.type === ModuleAccessRightType.FEATURE_WORK_TIME_TRACKING
    );

    if (
      right?.moduleAccessRightDenyReason ===
      ModuleAccessRightDenyReason.NOT_CONFIGURED
    ) {
      disabled = true;
      reason = t('ERROR.TIME_TRACKING.NOT_CONFIGURED');
    }

    return { disabled, reason };
  }, [rights, t]);
};
